import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MyGroceriesPage() {
  const { user, token } = useAuth();
  const [groceries, setGroceries] = useState([]);
  const [term, setTerm] = useState("Term 1");
  const [year, setYear] = useState(new Date().getFullYear().toString());

  useEffect(() => {
    if (user && token) fetchGroceries();
    // eslint-disable-next-line
  }, [user, token, term, year]);

  const fetchGroceries = async () => {
    if (!user || !token) return;
    const res = await axios.get(`${API}/groceries/submissions`, {
      params: { term, year },
      headers: { Authorization: `Bearer ${token}` },
    });
    // Only show groceries for the logged-in student
    const myGroceries = res.data.filter((g) => g.student_id === user.id);
    setGroceries(myGroceries);
  };

  return (
    <div>
      <h1 className="font-heading font-bold text-2xl mb-4">My Groceries for {term} {year}</h1>
      <div className="mb-4 flex gap-2">
        <select value={term} onChange={e => setTerm(e.target.value)} className="border rounded px-2 py-1">
          <option value="Term 1">Term 1</option>
          <option value="Term 2">Term 2</option>
          <option value="Term 3">Term 3</option>
        </select>
        <select value={year} onChange={e => setYear(e.target.value)} className="border rounded px-2 py-1">
          {Array.from({ length: 5 }).map((_, i) => {
            const y = new Date().getFullYear() - i;
            return <option key={y} value={y}>{y}</option>;
          })}
        </select>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Item</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Date Submitted</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groceries.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} className="text-center text-slate-500">No groceries submitted for this term.</TableCell>
            </TableRow>
          ) : (
            groceries.map((g, idx) => (
              <TableRow key={idx}>
                <TableCell>{g.item_name}</TableCell>
                <TableCell>✔️</TableCell>
                <TableCell>{g.created_at ? new Date(g.created_at).toLocaleDateString() : "-"}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
